import config from '@/configure/index'
import Cookies from 'js-cookie'

export const localSave = (key, value) => {
  Cookies.set(key, value)
}

export const localRead = (key) => {
  if (!(Cookies.get(key) || '') && key == 'local') {
    localSave('local', config.lang);
    return config.lang;
  }
  return Cookies.get(key) || '';
}